import React from 'react';
import styled from 'styled-components';

function UserAnalyticsTable({ users }) {
  // Format session time from seconds to human readable format
  const formatSessionTime = (seconds) => {
    if (seconds < 60) {
      return `${seconds}s`;
    }
    if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return remainingSeconds > 0
        ? `${minutes}m ${remainingSeconds}s`
        : `${minutes}m`;
    }
    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);
    return remainingMinutes > 0
      ? `${hours}h ${remainingMinutes}m`
      : `${hours}h`;
  };

  if (!users || users.length === 0) {
    return (
      <EmptyState>
        <EmptyMessage>No user data available</EmptyMessage>
      </EmptyState>
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <HeaderRow>
            <HeaderCell>User</HeaderCell>
            <HeaderCell>Active Time</HeaderCell>
            <HeaderCell>Comments</HeaderCell>
            <HeaderCell>Visits</HeaderCell>
            <HeaderCell>Engagement Score</HeaderCell>
          </HeaderRow>
        </TableHeader>
        <TableBody>
          {users.map((user, index) => (
            <BodyRow key={user.uid} $isEven={index % 2 === 0}>
              <BodyCell>
                <UserName>{user.name}</UserName>
                {/* <UserId>{user.uid}</UserId> */}
              </BodyCell>
              <BodyCell>
                <MetricValue>{formatSessionTime(user.sessionTime)}</MetricValue>
              </BodyCell>
              <BodyCell>
                <MetricValue>{user.comments}</MetricValue>
              </BodyCell>
              <BodyCell>
                <MetricValue>{user.visits}</MetricValue>
              </BodyCell>
              <BodyCell>
                <EngagementScore $score={user.engagementScore || 0}>
                  {user.engagementScore || 0}
                </EngagementScore>
              </BodyCell>
            </BodyRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const TableContainer = styled.div`
  overflow-x: auto;
  padding: 0 1.5rem 1.5rem 1.5rem;
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const TableHeader = styled.thead``;

const TableBody = styled.tbody``;

const HeaderRow = styled.tr``;

const BodyRow = styled.tr`
  background-color: ${({ $isEven }) => ($isEven ? '#f9f9f9' : 'white')};

  &:hover {
    background-color: var(--light-grey);
  }
`;

const HeaderCell = styled.th`
  border-bottom: 2px solid var(--light-grey);
  color: var(--brown);
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.75rem 1rem;
  text-align: left;

  /* &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  } */
`;

const BodyCell = styled.td`
  padding: 1rem;
  vertical-align: top;

  /* &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  } */
`;

const UserName = styled.div`
  color: var(--brown);
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
`;

const MetricValue = styled.div`
  color: var(--brown);
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
`;

const EngagementScore = styled.div`
  color: ${({ $score }) => {
    if ($score >= 80) return '#10B981'; // Green for high engagement (80-100)
    if ($score >= 40) return '#F59E0B'; // Orange for medium engagement (40-79)
    return '#EF4444'; // Red for very low engagement (0-39)
  }};
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
`;

const EmptyState = styled.div`
  padding: 2rem;
  text-align: center;
`;

const EmptyMessage = styled.p`
  color: var(--light-brown);
  font-family: 'Inter', sans-serif;
  margin: 0;
`;

export default UserAnalyticsTable;
